import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  Event as RouterEvent,
} from "@angular/router";
import { Subscription, filter, Subject, of } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap, catchError } from "rxjs/operators";
import { AuthService } from "src/app/features/auth/services/auth.service";
import { AuthDialogService } from "../../services/auth-dialog.service";
import { CartService } from "src/app/features/cart-detail/services/cart.service";
import { PersonalResponse } from "./../../../features/profile/models/personal-dashboard";
import { PersonalDashboardServiceService } from "src/app/features/profile/services/personal-dashboard-service.service";
import { ProductApiService } from "src/app/features/product-list/services/product-api.service";
import { QuickSearchProductDto } from "src/app/features/product-list/models/product-interface";

import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatDialog } from "@angular/material/dialog";
import { Category } from "src/app/features/product-list/models/category-interface";
import { environment } from "src/environments/environment";
import { FetchResponse } from "../../models/api-response.interface";
import { CommonDialogData } from "../../models/dialog.interface";
import { WishlistApiService } from "../../services/wishlist-api.service";
import { CommonDialogComponent } from "../common-dialog/common-dialog.component";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from 'src/app/core/services/translation.service'; // Import service của mình
import { AnalyticsService } from "src/app/core/services/analytics.service";
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() categories!: FetchResponse<Category[]>;
  activeCategoryId: string | number | null = null;
  subscription: Subscription = new Subscription();
  path: string = "/";
  userId = localStorage.getItem("userId");
  pageSize = 9999;
  pageIndex = 0;
  cartQuantities: number = 0;
  wishlistQuantities: number = 0;
  isMenuOpen = false;
  isLoggingOut = false;
  vendorBaseUrl: string = environment.vendorRegisterUrl;
  hoveredCategoryId: string | null = null;
  personalData: PersonalResponse | null = null;
  currentSubCategoryId: string | null = null;
  openedCategoryId: string | null = null;
  vendorConfirmUrl = "";
  mobileMenuOpen = false;
  guestMenuOpen = false;
  @ViewChild('guestMenuToggle') guestMenuToggle?: ElementRef<HTMLButtonElement>;
  selectedMobileCategory: any = null;
  isCategoryExpanded = false;
  isVendorMenuExpanded = false;
  searchKeyword: string = '';
  isMobileSearchOpen: boolean = false;
  isScrolled: boolean = false;

  searchSubject = new Subject<string>();
  quickSearchResults: QuickSearchProductDto[] = [];
  quickSearchTotalCount: number = 0;
  isQuickSearchLoading = false;
  showQuickSearchDropdown = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.isScrolled && window.scrollY < 10) {
      this.isScrolled = false;
    } else if (!this.isScrolled && window.scrollY > 150) {
      this.isScrolled = true;
    }
  }

  @ViewChild("mobileSlider", { static: false })
  mobileSlider!: ElementRef<HTMLDivElement>;

  activeSidebarCategoryId: string | null = null;
  host_img_url: string = environment.imageURL;
  private routeSub!: Subscription;

  constructor(
    private router: Router,
    public authService: AuthService,
    private __snackBar: MatSnackBar,
    private cartService: CartService,
    private personalDashboardService: PersonalDashboardServiceService,
    private matDialog: MatDialog,
    private destroyRef: DestroyRef,
    private wishlistService: WishlistApiService,
    private cdref: ChangeDetectorRef,
    private route: ActivatedRoute,
    public translate: TranslateService,
    public translationService: TranslationService, // Inject TranslationService
    private analytics: AnalyticsService,
    private productApiService: ProductApiService,
    private authDialogService: AuthDialogService
  ) {
    // Lưu ý: Đã xóa logic khởi tạo translate.use() tại đây 
    // vì TranslationService.init() đã tự động xử lý khi App khởi chạy.

    this.router.events
      .pipe(
        filter(
          (event: RouterEvent): event is NavigationEnd =>
            event instanceof NavigationEnd,
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({
        next: (event: NavigationEnd) => {
          this.path = event.urlAfterRedirects;
          this.mobileMenuOpen = false;
          this.guestMenuOpen = false;
          this.selectedMobileCategory = null;
          this.openedCategoryId = null; 
          this.activeSidebarCategoryId = null;
          try {
            const tree = this.router.parseUrl(event.urlAfterRedirects);
            const cat = tree.queryParams["category"];
            if (cat === undefined || cat === null || cat === "") {
              this.activeCategoryId = null;
            } else {
              const num = Number(cat);
              this.activeCategoryId = !isNaN(num) ? num : String(cat);
            }
          } catch (e) {
            this.activeCategoryId = null;
          }
        },
      });
  }

  // SỬA ĐỔI: Gọi qua TranslationService để đồng bộ LocalStorage
  changeLang(lang: string) {
    this.translationService.setLanguage(lang);
  }

  ngOnInit(): void {
    this.subscription.add(
      this.authService.isLoggedIn().subscribe((loggedIn) => {
        this.guestMenuOpen = false;
        if (loggedIn) {
          this.userId = localStorage.getItem("userId");
          this.fetchUserData();
        } else {
          this.userId = null;
          this.personalData = null;
          this.wishlistQuantities = 0;
        }
        this.cdref.detectChanges();
      })
    );

    this.subscription.add(
      this.cartService.cartCount$.subscribe((count) => {
        this.cartQuantities = count;
        this.cdref.detectChanges();
      })
    );

    this.routeSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let routeSnapshot = this.route.snapshot;
        while (routeSnapshot.firstChild) {
          routeSnapshot = routeSnapshot.firstChild;
        }

        this.currentSubCategoryId =
          routeSnapshot.queryParams["subCategory"] || null;
        this.cdref.detectChanges();
      });

    this.updateCurrentSubCategory();

    this.subscription.add(
      this.cartService.addToCart.subscribe({
        next: (isAddToCart: boolean) => {
          if (isAddToCart) {
            this.fetchCarts();
          }
        },
      }),
    );

    this.subscription.add(
      this.wishlistService.wishlistCount$.subscribe((count) => {
        this.wishlistQuantities = count;
        this.cdref.detectChanges();
      })
    );

    this.subscription.add(
      this.searchSubject.pipe(
        debounceTime(350),
        distinctUntilChanged(),
        switchMap((keyword) => {
          if (!keyword.trim()) {
            this.quickSearchResults = [];
            this.showQuickSearchDropdown = false;
            return of(null);
          }
          this.isQuickSearchLoading = true;
          this.showQuickSearchDropdown = true;
          this.cdref.detectChanges();
          return this.productApiService.quickSearch(keyword.trim()).pipe(
            catchError(() => {
              this.isQuickSearchLoading = false;
              this.cdref.detectChanges();
              return of(null);
            })
          );
        })
      ).subscribe((res) => {
        this.isQuickSearchLoading = false;
        if (res && res.success && res.data) {
          this.quickSearchResults = res.data.items || [];
          this.quickSearchTotalCount = res.data.totalCount ?? 0;
        }
        this.cdref.detectChanges();
      })
    );
  }

  // --- Các hàm Business Logic giữ nguyên ---

  /**
   * Wraps all case-insensitive occurrences of keyword in text with <strong class="qs-highlight">.
   */
  highlightText(text: string, keyword: string): string {
    if (!text) return '';
    const trimmed = keyword.trim();
    if (!trimmed) return text;
    const escaped = trimmed.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    return text.replace(regex, '<strong class="qs-highlight">$1</strong>');
  }

  onSubCategoryClick(subId: string) {
    this.router.navigate(["/product"], {
      queryParams: { subCategory: subId },
    });
  }

  toggleMobileCategory(categoryId: string) {
    this.openedCategoryId =
      this.openedCategoryId === categoryId ? null : categoryId;
  }

  private updateCurrentSubCategory(): void {
    let snapshot = this.route.snapshot;
    while (snapshot.firstChild) {
      snapshot = snapshot.firstChild;
    }
    this.currentSubCategoryId = snapshot.queryParams["subCategory"] || null;
  }

  isCategoryActive(category: any): boolean {
    if (!this.currentSubCategoryId || !category.subCategories) return false;

    return category.subCategories.some((sub: any) => {
      const subId = sub.id.toString();
      return subId === this.currentSubCategoryId;
    });
  }

  fetchCarts() {
    this.cartService.refreshCartCount(this.userId || undefined);
  }


  fetchUserData() {
    this.userId = localStorage.getItem("userId");
    if (!this.userId) {
      this.personalData = null;
      this.vendorConfirmUrl = `${this.vendorBaseUrl}/register-vendor`;
      this.cdref.detectChanges();
      return;
    }

    this.subscription.add(
      this.personalDashboardService.getPersonalData(this.userId).subscribe({
        next: (res) => {
          this.personalData = res?.data ?? null;
          this.setVendorUrl();
          this.cdref.detectChanges();
        },
        error: (err) => {
          console.error(err);
        },
      }),
    );
  }

  get vendorButtonText(): string {
    if (!this.userId) {
      return this.translate.instant('common.HEADER.VENDOR_REGISTER');
    }
    if (this.personalData?.isVendorVerified) {
      return this.translate.instant('common.HEADER.VENDOR_LOGIN');
    }
    return this.translate.instant('common.HEADER.VENDOR_REGISTER');
  }

  private setVendorUrl(): void {
    if (!this.personalData) return;

    const {
      isVendorVerified,
      isSocialLogin,
      loginProvider,
      email
    } = this.personalData;

    if (isVendorVerified === true) {
      this.vendorConfirmUrl = `${this.vendorBaseUrl}/login`;
      return;
    }

    if (isVendorVerified === false) {

      // if (isSocialLogin && loginProvider) {
      //   this.vendorConfirmUrl =
      //     `${this.vendorBaseUrl}/register-vendor-social?provider=${loginProvider}`;
      //   return;
      // }

      if (!isSocialLogin && email) {
        this.vendorConfirmUrl =
          `${this.vendorBaseUrl}/ConfirmVendorMailUser?email=${encodeURIComponent(email)}`;
        return;
      }

      this.vendorConfirmUrl = `${this.vendorBaseUrl}/register-vendor`;
    }

  }

  get showVendorRegister(): boolean {
    return true;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    if (this.routeSub) this.routeSub.unsubscribe();
  }

  logout(): void {
    this.isMenuOpen = false;
    this.isLoggingOut = true;

    // Xóa UserId khỏi Google Analytics
    this.analytics.setUserId(null);

    this.authService.logoutApi().subscribe({
      next: () => this.executeLocalLogout(),
      error: () => this.executeLocalLogout() // Dù lỗi mạng thì vẫn dọn dẹp ở FE
    });
  }

  private executeLocalLogout(): void {
    // 1. Lưu tạm ngôn ngữ hiện tại
    const currentLang = localStorage.getItem('user_lang');

    this.authService.removeToken();
    localStorage.clear(); // Xóa sạch bộ nhớ

    // 2. Trả lại ngôn ngữ ngay lập tức sau khi clear
    if (currentLang) {
      localStorage.setItem('user_lang', currentLang);
    }

    this.userId = null;
    this.personalData = null;
    this.cartQuantities = 0;
    this.setVendorUrl();
    this.matDialog.closeAll();

    this.__snackBar.openFromComponent(SnackbarComponent, {
      data: {
        message: this.translate.instant('common.HEADER.LOGOUT_SUCCESS'),
        type: "success",
      },
      duration: 3000,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: ["custom-snackbar"],
    });

    setTimeout(() => {
      if (window.location.pathname === '/') {
        window.location.reload();
      } else {
        window.location.href = "/";
      }
    }, 1000);
  }

  // --- Các hàm UI/Event giữ nguyên ---
  onSearch(): void {
    if (this.searchKeyword.trim()) {
      this.showQuickSearchDropdown = false;
      this.router.navigate(["/product"], {
        queryParams: { search: this.searchKeyword.trim() }
      });
      this.closeMenu();
    }
  }

  onSearchInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const val = inputElement.value;
    
    // Sanitize input: allow alphanumeric, spaces, basic punctuation and Vietnamese chars
    const sanitized = val.replace(/[^a-zA-Z0-9\s\-_.,À-ỹ]/g, '');
    
    if (val !== sanitized) {
      inputElement.value = sanitized;
    }

    this.searchKeyword = sanitized;
    this.searchSubject.next(sanitized);
  }

  goToProduct(id: string): void {
    this.showQuickSearchDropdown = false;
    this.searchKeyword = '';
    this.searchSubject.next('');
    this.router.navigate(['/product', id]);
  }

  closeMenu(): void {
    this.mobileMenuOpen = false;
    this.guestMenuOpen = false;
  }

  toggleGuestMenu(): void {
    this.guestMenuOpen = !this.guestMenuOpen;
    this.isMobileSearchOpen = false;
  }

  @HostListener('document:keydown.escape')
  closeGuestMenuOnEscape(): void {
    if (!this.guestMenuOpen) return;
    this.guestMenuOpen = false;
    this.guestMenuToggle?.nativeElement.focus();
  }

  @HostListener('window:resize')
  closeGuestMenuOnDesktop(): void {
    if (window.innerWidth > 768) this.guestMenuOpen = false;
  }

  scrollSlider(direction: number) {
    const slider = this.mobileSlider.nativeElement;
    const scrollAmount = 120;
    slider.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth",
    });
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    this.selectedMobileCategory = null;
  }

  toggleMobileSearch(): void {
    this.guestMenuOpen = false;
    this.isMobileSearchOpen = !this.isMobileSearchOpen;
  }

  openMobileCategory(cate: any) {
    this.selectedMobileCategory = cate;
  }

  onMenuEnter(categoryId: string) {
    this.openedCategoryId = categoryId;
    this.activeSidebarCategoryId = categoryId;
  }

  onMenuLeave() {
    this.openedCategoryId = null;
    this.activeSidebarCategoryId = null;
  }

  onCategoryTabClick(categoryId: string, event: Event) {
    if (this.openedCategoryId === categoryId) {
      this.onMenuLeave();
      event.preventDefault(); 
    } else {
      this.openedCategoryId = categoryId;
      this.activeSidebarCategoryId = categoryId;
    }
  }

  onSidebarEnter(cateId: string) {
    this.activeSidebarCategoryId = cateId;
  }

  openAuthModal(mode: 'login' | 'register' = 'login'): void {
    this.closeMenu();
    this.authDialogService.openAuthDialog(mode, undefined, 'header').subscribe((loggedIn) => {
      if (loggedIn) {
        this.fetchUserData();
      }
    });
  }

  onCartClick(): void {
    if (!this.isLoggingOut) {
      this.authService.isLoggedIn().subscribe((loggedIn) => {
        if (loggedIn) {
          this.router.navigate(["/cart-details"]);
        } else {
          this.openAuthModal('login');
        }
      });
    }
  }

  onWishlistClick(): void {
    if (this.isLoggingOut) return;
    this.closeMenu();
    this.authService.isLoggedIn().subscribe((loggedIn) => {
      if (loggedIn) {
        this.router.navigate(["/profiles"], {
          queryParams: { tab: "wishlist" },
        });
      } else {
        this.openAuthModal('login');
      }
    });
  }

  onProfileClick(): void {
    if (this.isLoggingOut) return;
    this.closeMenu();
    this.authService.isLoggedIn().subscribe((loggedIn) => {
      if (loggedIn) {
        this.router.navigate(["/profiles"]);
      } else {
        this.openAuthModal('login');
      }
    });
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.guestMenuOpen && !target.closest('.guest-navigation, .guest-menu-toggle')) {
      this.guestMenuOpen = false;
    }
    const searchContainer = document.querySelector(".search-bar") as HTMLElement | null;
    
    if (searchContainer && !searchContainer.contains(target)) {
      this.showQuickSearchDropdown = false;
    }

    if (!this.isMenuOpen) return;
    const side = document.querySelector(".side-menu") as HTMLElement | null;
    const toggle = document.querySelector(".menu-toggle") as HTMLElement | null;

    if (side && side.contains(target)) return;
    if (toggle && toggle.contains(target)) return;
    this.closeMenu();
  }

  get categoriesWithSub() {
    const items = this.categories?.items ?? [];
    return items
      .filter((c) =>
        c.subCategories?.length ||
        c.nameCode?.trim().toUpperCase() === 'OP' ||
        /đồng phục|uniform/i.test(c.name ?? '')
      )
      .slice()
      .sort((a: any, b: any) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
  }

  categoryLabel(category: Category): string {
    const name = category.name?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
    const code = category.nameCode?.trim().toUpperCase();
    if (code === 'CNH' || code === 'PERSONALIZATION'
      || name === 'ca nhan hoa' || name === 'personalization' || name === 'personalisation') {
      return this.translate.instant('common.HEADER.DESIGN_YOUR_OWN');
    }
    return category.name;
  }

  resolveImageUrl(path?: string | null): string {
    if (!path) return '';

    if (path.startsWith('http')) {
      return path;
    }
    if (!this.host_img_url || this.host_img_url === '/') {
      return path;
    }
    return `${this.host_img_url}${path}`;
  }
}
